module.exports = __webpack_public_path__ + "static/windmill-logo-e0af9d4fd37bef4ef6d4d4f9118de1d9.png";